import { useParams, useRouteMatch } from 'react-router-dom'

import { CanvasFocus, deriveCanvasFocus } from '../../../canvas/scope'

/**
 * Which entity - if any - the current Preview route focuses on.
 *
 * The same route reading that backs `CanvasScopeProvider`, called as a function
 * rather than through the context because this runs above the provider: the
 * page handed to the scope depends on the focus.
 *
 * Telling the renderer to isolate a focused frame is `useIsolateFocusedFrame`,
 * inside the canvas, which serves both hosts.
 */
export function usePreviewSingleEntity(): CanvasFocus {
  const { path } = useRouteMatch()
  const { frameUUID, sectionUUID } = useParams<{
    frameUUID?: string
    sectionUUID?: string
  }>()

  return deriveCanvasFocus(path, { frameUUID, sectionUUID })
}
